module.exports = __webpack_public_path__ + "img/history_icon.c34409b6.svg";